export const PLACES_SESSION_IDLE_TIMEOUT_MS = 3 * 60 * 1000;

type TokenFactory = () => string;
type Clock = () => number;

const createUuid = (): string => {
  if (typeof globalThis.crypto?.randomUUID !== 'function') {
    throw new Error('Secure UUID generation is unavailable in this browser');
  }
  return globalThis.crypto.randomUUID();
};

/**
 * Keeps one Google Places billing token for the autocomplete requests that
 * lead to a single Place Details selection.
 */
export class GooglePlacesSession {
  private token: string | null = null;
  private lastActivityAt = 0;

  constructor(
    private readonly tokenFactory: TokenFactory = createUuid,
    private readonly now: Clock = Date.now,
    private readonly idleTimeoutMs = PLACES_SESSION_IDLE_TIMEOUT_MS,
  ) {}

  getToken(): string {
    const currentTime = this.now();
    const expired =
      this.token !== null &&
      currentTime - this.lastActivityAt >= this.idleTimeoutMs;

    if (!this.token || expired) {
      this.token = this.tokenFactory();
    }

    this.lastActivityAt = currentTime;
    return this.token;
  }

  complete(expectedToken: string): void {
    if (this.token === expectedToken) {
      this.reset();
    }
  }

  reset(): void {
    this.token = null;
    this.lastActivityAt = 0;
  }
}
